package com.platforma.chat_domain

import com.platforma.chat_domain.use_case.chats.TableChatsUseCase

data class ChatsUseCase(
    val table: TableChatsUseCase
)
